<template>
  <v-app id="app">
    <Layout v-if="$route.path.startsWith('/') && !$route.path.endsWith('login') && !$route.path.endsWith('reset') && userStore?.user?.email" />
    <LoginFlow v-if="$route.path.endsWith('login')" />
    <ResetFlow v-if="$route.path.endsWith('reset')" />
    <EmbeddedSignup v-if="$route.path.endsWith('signup')" />
  </v-app>
</template>
<script lang="ts">
import {Component, Vue, toNative, Watch} from "vue-facing-decorator";
import LoginFlow from "@/views/login/LoginFlow.vue";
import ResetFlow from "@/views/login/ResetFlow.vue";
import EmbeddedSignup from "@/views/EmbeddedSignup.vue";
import Layout from "@/views/Layout.vue";
import {useTenantStore} from "@/stores/tenantStore";
import {RouteScope} from "@/router";
import {useUserStore} from "@/stores/userStore";
import {useAppStore} from "@/stores/appStore";

@Component({ components: { LoginFlow, ResetFlow, Layout, EmbeddedSignup }})
class App extends Vue {
  private tenantStore = useTenantStore();
  private userStore = useUserStore();
  private appStore = useAppStore();

  private mounted() {
    document.title = this.appStore.appName;
  }

  @Watch('$route')
  private async onRouteChange() {
    if (this.$route.meta.scope === RouteScope.Public) {
      this.tenantStore.setTenantId(null);
      await this.tenantStore.getTenantTheme();
    }
    if (this.$vuetify.theme.themes.currentTheme.colors?.primary !== this.tenantStore.tenantTheme?.primary || this.$vuetify.theme.themes.currentTheme.colors?.secondary !== this.tenantStore.tenantTheme?.secondary) {
      this.$vuetify.theme.themes.currentTheme = {
        ...this.$vuetify.theme.themes.currentTheme,
        colors: {
          ...this.$vuetify.theme.themes.currentTheme.colors,
          primary: this.tenantStore.tenantTheme?.primary || this.$vuetify.theme.themes.currentTheme.colors?.primary || this.tenantStore.defaultTheme.primary,
          secondary: this.tenantStore.tenantTheme?.secondary || this.$vuetify.theme.themes.currentTheme.colors?.secondary || this.tenantStore.defaultTheme.secondary
        }
      }
    }
  }
}
export default toNative(App)
</script>
<style>
</style>
